<template>
  <div
    class="fixed top-0 left-0 z-[100]"
    :class="{
      'pointer-events-none': guidIsVisible,
    }"
  >
    <div
      class="absolute w-full h-full duration-300 pointer-events-none"
      :class="{
        'opacity-100': guidIsVisible,
        'opacity-0': !guidIsVisible,
      }"
      tabindex="-1"
    >
      <div
        class="w-[100vw] h-[100vh] top-0 fixed"
        :class="{
          'pointer-events-none': !guidIsVisible,
          'pointer-events-auto': guidIsVisible,
        }"
        :style="{ right: 'calc(100vw - ' + guideWindowLeft + 'px)' }"
        @click.stop="onOutOfBoxClicked"
      ></div>
      <div
        class="w-[100vw] h-[100vh] fixed"
        :class="{
          'pointer-events-none': !guidIsVisible,
          'pointer-events-auto': guidIsVisible,
        }"
        :style="{ bottom: 'calc(100vh - ' + guideWindowTop + 'px)' }"
        @click.stop="onOutOfBoxClicked"
      ></div>
      <div
        class="w-[100vw] h-[100vh] fixed"
        :class="{
          'pointer-events-none': !guidIsVisible,
          'pointer-events-auto': guidIsVisible,
        }"
        :style="{ top: 'calc(' + (guideWindowTop + guideWindowHeight) + 'px)' }"
        @click.stop="onOutOfBoxClicked"
      ></div>
      <div
        class="w-[100vw] h-[100vh] top-0 fixed"
        :class="{
          'pointer-events-none': !guidIsVisible,
          'pointer-events-auto': guidIsVisible,
        }"
        :style="{
          left: 'calc(' + (guideWindowLeft + guideWindowWidth) + 'px)',
        }"
        @click.stop="onOutOfBoxClicked"
      ></div>
      <div
        class="rounded-2xl border border-primary flex justify-center pointer-events-none"
        :style="{
          width: guideWindowWidth + 'px',
          height: guideWindowHeight + 'px',
          top: guideWindowTop + 'px',
          left: guideWindowLeft + 'px',
        }"
        style="
          box-shadow: #0004 0 0 max(200vh, 200vw) max(200vh, 200vw);
          position: relative;
        "
      >
        <div class="absolute top-full">
          <div
            class="rounded translate-y-[25px] bg-white shadow-xl duration-300 w-4 h-4 rotate-45"
          ></div>
        </div>
        <div class="absolute top-full">
          <div
            class="rounded-xl glassBg px-8 py-4 text-xl shadow-xl duration-300 text-center w-max"
            :class="{
              'translate-y-[30px]': guidIsVisible,
              'translate-x-[calc(-1*50%+20px)]':
                tourGuideTextPositionX == 'left',
              'translate-x-[calc(50%+20px)]': tourGuideTextPositionX == 'right',
            }"
          >
            <span v-html="guideText"></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import AppDataProperty from '../appData/AppDataProperty.vue'

export default defineComponent({
  name: 'TourGuide',
  components: { AppDataProperty },
  props: {},
  data() {
    return {
      guideWindowLeft: 0,
      guideWindowTop: 0,
      guideWindowWidth: 0,
      guideWindowHeight: 0,
      guidIsVisible: false,
      guideText: '',
      tourGuideTextPositionX: 'center',
      eventsIds: [],
    }
  },
  mounted() {
    const id = this.$Events.handleEvent(
      'required_tour_guide',
      this.onTourGuidRequired,
    )
    this.eventsIds.push(id)
    document.body.addEventListener(
      'click',
      () => {
        this.finishGuid()
      },
      { passive: true },
    )
  },
  beforeUnmount() {
    this.eventsIds.forEach(this.$Events.removeHandler)
  },
  methods: {
    onTourGuidRequired({ id, ...args }) {
      if (id == 'service') {
        this.loadServicesGuide()
      } else if (id == 'affiliation') {
        this.loadAffiliationGuide()
      } else {
        this.makeTourGuid({ id, ...args })
      }
    },
    makeTourGuid({
      el = '',
      title = '',
      id = '',
      maxRepeat = 1,
      widthMultiplier = 1,
      heightMultiplier = 1,
      marge = 5,
      position = 'bottom-center',
      hideOnBotomSheet = true,
    }) {
      this.resetTourGuid()
      if (hideOnBotomSheet) {
        const bottomsheetVisible = document.querySelector('.bottomsheetContent')
        if (!!bottomsheetVisible) return
      }
      let nbFinished = this.$QuickStorage.getStored(`nbFinishedGuid-${id}`)
      if (!nbFinished) nbFinished = 0
      if (maxRepeat && nbFinished >= maxRepeat) return
      let element = el
      if (typeof element == 'string') element = document.querySelector(el)
      if (!element) return
      const rect = element.getBoundingClientRect()
      const elementLeft = rect.left
      const elementTop = rect.top
      const elementWidth = rect.width
      const elementHeight = rect.height
      this.guideWindowLeft = elementLeft - marge
      this.guideWindowTop = elementTop - marge
      this.guideWindowWidth = elementWidth * widthMultiplier + marge * 2
      this.guideWindowHeight = elementHeight * heightMultiplier + marge * 2
      this.guideText = title

      if (/left/i.test(position)) {
        this.tourGuideTextPositionX = 'left'
      } else if (/right/i.test(position)) {
        this.tourGuideTextPositionX = 'right'
      } else this.tourGuideTextPositionX = 'center'

      this.guidIsVisible = true

      this.finishGuid = () => {
        if (!this.guidIsVisible) return
        this.guidIsVisible = false
        if (id) {
          nbFinished++
          this.$QuickStorage.storeData(`nbFinishedGuid-${id}`, nbFinished)
        }
        this.finishGuid = () => {}
      }
    },
    loadServicesGuide() {
      this.makeTourGuid({
        el: '#service_button_1xbet',
        title: '',
        id: 'services',
        maxRepeat: 3,
        widthMultiplier: 1,
        marge: -10,
        position: 'bottom-center',
      })
      // this.resetTourGuid()
      // let nbFinishedServiceGuide = this.$QuickStorage.getStored(
      //   'nbFinishedServiceGuide',
      // )
      // if (!nbFinishedServiceGuide) nbFinishedServiceGuide = 0
      // if (nbFinishedServiceGuide >= 3) return
      // const service1 = document.querySelector('#service_button_1xbet')
      // if (!service1) return
      // const service1Rect = service1.getBoundingClientRect()
      // this.guideWindowLeft = service1Rect.left
      // this.guideWindowTop = service1Rect.top - 5
      // this.guideWindowWidth = service1Rect.width * 3
      // this.guideWindowHeight = service1Rect.height + 10
      // this.guideText = this.$t('tourGuide.funding')
      // this.guidIsVisible = true
      // this.finishGuid = () => {
      //   this.guidIsVisible = false
      //   nbFinishedServiceGuide++
      //   this.$QuickStorage.storeData(
      //     'nbFinishedServiceGuide',
      //     nbFinishedServiceGuide,
      //   )
      // }
    },
    loadAffiliationGuide() {
      this.resetTourGuid()
      let nbFinishedAffiliationGuide = this.$QuickStorage.getStored(
        'nbFinishedAffiliationGuide',
      )
      if (!nbFinishedAffiliationGuide) nbFinishedAffiliationGuide = 0
      if (nbFinishedAffiliationGuide >= 1) return
      const affiliationButton = document.querySelector('#affiliation_button')
      if (!affiliationButton) return
      const buttonRect = affiliationButton.getBoundingClientRect()
      this.guideWindowLeft = buttonRect.left - 10
      this.guideWindowTop = buttonRect.top - 10
      this.guideWindowWidth = buttonRect.width + 20
      this.guideWindowHeight = buttonRect.height + 20
      this.tourGuideTextPositionX = 'left'
      this.guideText = this.$t('tourGuide.bonusText')
      this.guidIsVisible = true
      this.finishGuid = () => {
        this.guidIsVisible = false
        nbFinishedAffiliationGuide++
        this.$QuickStorage.storeData(
          'nbFinishedAffiliationGuide',
          nbFinishedAffiliationGuide,
        )
      }
    },
    resetTourGuid() {
      this.tourGuideTextPositionX = 'center'
    },
    onOutOfBoxClicked() {
      this.finishGuid = () => {}
      this.guidIsVisible = false
    },
    finishGuid() {},
  },
  watch: {},
})
</script>
